<template>
	<div class="c-deactivated-empty-state">
		<PageHeader :title="title" :showMenu="false">
			<template v-slot:title>{{ title }}</template>
		</PageHeader>

		<div class="c-deactivated-empty-state__content">
			<svg
				class="c-deactivated-empty-state__icon"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				aria-hidden="true"
			>
				<path d="M11.5 20.5H6.5C5.39543 20.5 4.47532 19.5972 4.64901 18.5063C5.25443 14.704 7.70476 12.4295 12 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
				<circle cx="12" cy="7.5" r="4.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M15.5 14.5L18.5 17.5M18.5 17.5L21.5 20.5M18.5 17.5L21.5 14.5M18.5 17.5L15.5 20.5" stroke="black" stroke-linecap="round"/>
			</svg>

			<h2>Your account has been deactivated</h2>
			<p>Subscribe to a plan to activate it and regain access.</p>
			<router-link to="/profile/billing" class="btn btn-primary">Subscribe to a plan</router-link>
		</div>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header.vue';

export default {
	components: {
		PageHeader,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.c-deactivated-empty-state {
	min-height: 100vh;

	&__content {
		max-width: 440px;
		margin: clamp(3rem, 12vh, 8rem) auto 0;
		padding: 0 var(--spacer-sm) var(--spacer);
		text-align: center;
	}

	&__icon {
		display: inline-block;
		width: 72px;
		height: 72px;
		margin-bottom: var(--spacer-sm);
	}

	h2 {
		margin-bottom: 0.75rem;
	}

	p {
		margin-bottom: var(--spacer-sm);
	}
}
</style>
